import React, { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';

const BusinessTypeForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();


  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
      });
    }
    else {
      // Reset form when record is null (for adding new state)
      form.resetFields();
    }
  }, [record, form]);

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update Business Type" : "Add Business Type"}
      okText="Submit"
      cancelText="Cancel"
      // onCancel={onCancel}
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
            form.resetFields();
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >

        <Form.Item
          name="type"
          label="Type"
          rules={[{ required: true, message: 'Please enter the model type!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="dbname"
          label="DB NAME"
          rules={[{ required: true, message: 'Please enter the model dbname!' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BusinessTypeForm;